import useSWR from 'swr';
import useSWRMutation from 'swr/mutation';
import { MessageType } from '@upstart/harmony/lib/legos/websiteTypes';
import {
  UpdateDealerSetupFeatureConfigsRequest,
  useDealerSetupService,
} from 'hooks/services';
import { PageMessage } from 'components/GlobalUI';
import { getKey, Resource } from './key';

export const useGetDealerSetupFeatureConfigs = (
  dealerId: string | null | undefined,
) => {
  const { getFeatureConfigs } = useDealerSetupService();
  return useSWR(
    dealerId
      ? getKey(Resource.DEALER_SETUP_FEATURE_CONFIGS, { dealerId })
      : null,
    ({ params }) => getFeatureConfigs(params),
    { revalidateOnFocus: false },
  );
};

export const useUpdateDealerSetupFeatureConfigs = (
  dealerId: string | null | undefined,
) => {
  const { updateFeatureConfigs } = useDealerSetupService();
  return useSWRMutation(
    dealerId
      ? getKey(Resource.DEALER_SETUP_FEATURE_CONFIGS, { dealerId })
      : null,
    ({ params }, { arg }: { arg: UpdateDealerSetupFeatureConfigsRequest }) =>
      updateFeatureConfigs({ dealerId: params.dealerId, featureConfigs: arg }),
    {
      populateCache: true,
      revalidate: false,
      onError: () =>
        PageMessage({
          type: MessageType.ERROR,
          message: 'Failed to save some dealer configurations',
        }),
    },
  );
};
